<template>
  <nav :aria-labelledby="$attrs['aria-label'] ? undefined : titleId">
    <slot :id="titleId" name="sidebar-title">
      <h2 :id="titleId" class="mb-4 title-2 ">
        {{ $t.helpCenterSidebarHeader }}
      </h2>
    </slot>
    <ul>
      <li v-for="({ url, title, children }, i) in links" :key="i" :class="brandClasses.listItem">
        <vf-accordion
          v-if="children?.length"
          :class="brandClasses.accordion"
          :open="isActive(url) || children.some(({ url }) => isActive(url))"
          variant="aligned"
        >
          <template #toggle="{ expanded }">
            <span :class="brandClasses.accordionSpan">
              {{ title }}
              <vf-icon :dir="expanded ? 'up' : 'down'" name="chevron" :size="chevronSize" />
            </span>
          </template>
          <ul>
            <li v-for="(child, j) in children" :key="j" class="ml-2 mt-4 ">
              <base-link
                active-hash-class="fw-bold"
                :class="brandClasses.accordionLink"
                :exact-active-class="isMounted && !route.hash && !child.url.includes('#') ? 'fw-bold' : undefined"
                :to="child.url"
              >
                {{ child.title }}
              </base-link>
            </li>
          </ul>
        </vf-accordion>
        <base-link
          v-else
          active-hash-class="underlined"
          class="hover:underlined"
          :data-scroll-el="useLocalisedRoute(url)"
          :exact-active-class="isMounted && !route.hash && !url.includes('#') ? 'underlined' : undefined"
          :to="url"
        >
          {{ title }}
        </base-link>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import type { PageChildrenData } from '#root/api/clients/content/data-contracts'

const { localisedPath = '/help' } = defineProps<{
  localisedPath?: string
}>()

const { brandClasses, chevronSize } = useAppConfig().pages.help.sidebar

const route = useRoute()
const { $t } = useNuxtApp()
const titleId = useId()
const links = ref<Awaited<PageChildrenData['content']>>([])
const isMounted = useMounted()

try {
  const { getPageChildren } = useCms()
  links.value = await getPageChildren(localisedPath.substring(1), { lvl2: true })
}

catch (err: any) {
  log.error(`[@domains/commerce/components/help/Sidebar.vue] Error: ${err.message}`)
}

const scrollToTop = () =>
  scrollTo({ top: 0, behavior: 'smooth' })

watch(route, scrollToTop)

const isActive = (url: string) => route.fullPath === url
</script>
